<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalExihibitionsDisplays",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"8. (V). (a) Did you exhibit any portion of your stock at any exhibition, other than one promoted or financially assisted by any Public Authority or by any Trade Association, or entrust goods for any display or performance during the past 12 months? If so, give full particulars including value.",
					component: "longText",
					bindTo: "case.facts.exhibitStockDetails"
				},
				{
					label:
						"8. (V). (b) Do you exhibit goods, in any showcase in any hotel, club or elsewhere away from your premises? If so, give full particulars including values and details of protections (i.e. type of glass, locks and the like).",
					component: "longText",
					bindTo: "case.facts.exhibitGoodsDetails"
				}
			]
		}
	}
}
</script>
